/* Recipe page behaviour - sections/nn-recipe-page.liquid. Redesign 2026-10-07,
   docs/knowledge/recipe-page-redesign/.
   - Print and Share (Web Share API on phones; else a panel with Copy link, Facebook, Pinterest).
   - Add to cart in place (the cart drawer's "customers also bought" button, snippets/nn-add-to-cart-button.liquid,
     beside the product link; blog articles list theirs after the body, snippets/nn-article-products.liquid): POST cart/add.js, re-render the cart sections and show the theme's own
     "added to cart" pop-up (Alpine store xCartNoti, assets/cart-noti.js). The drawer is never opened.
   - Sold out: inline Back in Stock sign-up through the app's documented API, BIS.create(email,
     variantId, productId), and a link that opens the Gorgias chat pre-filled (the 404 page's pattern,
     sections/main-404.liquid). Without the chat the link stays a plain contact-page link. */
(function () {
  function status(root, text) {
    var el = root.querySelector('[data-rp-status]');
    if (el) { el.textContent = ''; setTimeout(function () { el.textContent = text; }, 50); }
  }

  function sectionIds() {
    try {
      return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) { return []; }
  }

  function addToCart(root, btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var name = btn.dataset.pname;
    var label = btn.getAttribute('aria-label');
    var line = btn.closest('li');
    var err = line ? line.querySelector('.nn-rp-add__err') : null;
    btn.setAttribute('aria-disabled', 'true');
    if (err) err.hidden = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'error');
      if (window.Alpine) {
        try { Alpine.store('xCartHelper').reRenderSections(res.sections); } catch (e) {}
        var noti = Alpine.store('xCartNoti');
        if (noti) noti.setItem(res);
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      }
      var text = btn.querySelector('[data-rp-add-label]');
      var was = text ? text.textContent : '';
      if (text) text.textContent = 'Added';
      btn.classList.add('is-added');
      btn.setAttribute('aria-label', 'Added: ' + name);
      status(root, 'Added ' + name + ' to your cart.');
      setTimeout(function () { btn.classList.remove('is-added'); btn.setAttribute('aria-label', label); if (text) text.textContent = was; }, 2500);
    }).catch(function () {
      var msg = 'We could not add ' + name + '. Please try again.';
      if (err) { err.textContent = msg; err.hidden = false; }
      status(root, msg);
    }).then(function () { btn.removeAttribute('aria-disabled'); });
  }

  /* Add all (blog articles, owner 2026-10-13): every in-stock item in the list, quantity 1, in ONE request.
     After success the button stays in its "Added" state until the page reloads, so a second click cannot double the cart. */
  function addAll(root, btn) {
    if (btn.dataset.busy === 'true' || btn.disabled) return;
    var items = [];
    root.querySelectorAll('[data-rp-add]').forEach(function (b) {
      items.push({ id: Number(b.dataset.variant), quantity: 1 });
    });
    var err = root.querySelector('[data-rp-all-err]');
    var text = btn.querySelector('.button-text') || btn;
    var was = text.textContent;
    if (!items.length) return;
    btn.dataset.busy = 'true';
    if (err) err.hidden = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'error');
      if (window.Alpine) {
        try { Alpine.store('xCartHelper').reRenderSections(res.sections); } catch (e) {}
        var noti = Alpine.store('xCartNoti');
        var first = res.items && res.items[0];
        if (noti && first) noti.setItem(first);
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      }
      text.textContent = 'Added ' + items.length + ' items';
      btn.classList.add('is-added');
      btn.disabled = true; /* stays until reload. Not aria-disabled: theme.css hides button[aria-disabled=true]. */
      status(root, 'Added ' + items.length + ' items to your cart.');
    }).catch(function () {
      var msg = 'We could not add all of these items. One may have just sold out. Please try again or add them one at a time.';
      text.textContent = was;
      if (err) { err.textContent = msg; err.hidden = false; }
      status(root, msg);
      btn.dataset.busy = 'false';
    });
  }

  function bisSubmit(root, box, form) {
    var input = form.querySelector('input[type=email]');
    var msg = form.querySelector('.nn-rp-bis__msg');
    var email = input.value.trim();
    input.removeAttribute('aria-invalid');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.setAttribute('aria-invalid', 'true');
      msg.textContent = 'Please enter an email address, like name@example.com.';
      input.focus();
      return;
    }
    if (!window.BIS || typeof window.BIS.create !== 'function') {
      msg.textContent = 'Sign-up is not available right now. Please use the chat link or contact us.';
      return;
    }
    msg.textContent = 'Sending…';
    window.BIS.create(email, Number(box.dataset.variant), Number(box.dataset.product)).then(function (res) {
      if (res && res.status === 'OK') {
        msg.textContent = 'Thank you. We will email you when ' + box.dataset.pname + ' is back.';
        form.querySelector('.nn-rp-bis__row').hidden = true;
        status(root, msg.textContent);
      } else {
        var errs = res && res.errors ? Object.keys(res.errors).map(function (k) { return res.errors[k].join(' '); }).join(' ') : '';
        input.setAttribute('aria-invalid', 'true');
        msg.textContent = errs || 'Something went wrong. Please try again.';
      }
    });
  }

  function chatReady() {
    return window.GorgiasChat && typeof window.GorgiasChat.open === 'function';
  }

  function openChat(root, box, link, ev) {
    if (!chatReady()) return; /* plain link to the contact page */
    ev.preventDefault();
    var chat = window.GorgiasChat;
    /* Owner 2026-10-07: ask for the same or a close flavor that still fits the recipe's plan. */
    var plan = root.dataset.protocol ? ' that also works for the ' + root.dataset.protocol + ' plan' : '';
    var text = 'Hi, ' + box.dataset.pname + ' is out of stock: ' + box.dataset.purl +
      '. Could you suggest an in-stock product in the same or a close flavor' + plan +
      (root.dataset.kind === 'article' ? ', mentioned in this article: ' : ', for this recipe: ') + root.dataset.name + '?';
    var fill = function () {
      if (typeof chat.setCurrentInput === 'function') { try { chat.setCurrentInput(text); } catch (e) {} }
    };
    /* Gorgias drops input set before its widget has finished starting, and opening the panel can reset it
       (seen by the owner 2026-10-07 on a browser that had chatted before). So: wait for init, fill, open,
       then fill again as the panel settles. */
    /* Backup for any chat state that still drops the input: copy the message (inside the click, so the
       browser allows it) and say so under the link. */
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        var note = box.querySelector('.nn-rp-oos__copied');
        if (note) note.hidden = false;
      }, function () {});
    }
    var ready = typeof chat.init === 'function' ? chat.init() : null;
    (ready && ready.then ? ready : Promise.resolve()).then(function () {
      fill();
      chat.open();
      [300, 900, 1800].forEach(function (ms) { setTimeout(fill, ms); });
    });
  }

  function share(root, btn) {
    var url = root.dataset.url;
    var title = root.dataset.name;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (touch && navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    var open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (open) panel.querySelector('button, a').focus();
  }

  function copyLink(root, btn) {
    var url = root.dataset.url;
    var done = function () { btn.textContent = 'Link copied'; status(root, 'Link copied.'); setTimeout(function () { btn.textContent = 'Copy link'; }, 2500); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
    } else {
      window.prompt('Copy this link:', url);
    }
  }

  function init(root) {
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-rp-print],[data-rp-share],[data-rp-copy],[data-rp-add],[data-rp-add-all],[data-rp-oos-toggle],[data-rp-chat]');
      if (!t) return;
      if (t.tagName === 'A' && t.getAttribute('role') === 'button') ev.preventDefault();
      if (t.hasAttribute('data-rp-print')) window.print();
      else if (t.hasAttribute('data-rp-share')) share(root, t);
      else if (t.hasAttribute('data-rp-copy')) copyLink(root, t);
      else if (t.hasAttribute('data-rp-add-all')) addAll(root, t);
      else if (t.hasAttribute('data-rp-add')) addToCart(root, t);
      else if (t.hasAttribute('data-rp-oos-toggle')) {
        /* The form replaces the button; focus moves into the email field. */
        var form = document.getElementById(t.getAttribute('aria-controls'));
        form.hidden = false;
        t.setAttribute('aria-expanded', 'true');
        t.hidden = true;
        form.querySelector('input').focus();
      } else if (t.hasAttribute('data-rp-chat')) openChat(root, t.closest('[data-rp-oos]'), t, ev);
    });
    root.addEventListener('submit', function (ev) {
      var form = ev.target.closest('.nn-rp-bis');
      if (!form) return;
      ev.preventDefault();
      bisSubmit(root, form.closest('[data-rp-oos]'), form);
    });
    root.addEventListener('keydown', function (ev) {
      if (ev.key === ' ' && ev.target.matches('a[role="button"]')) { ev.preventDefault(); ev.target.click(); return; }
      if (ev.key !== 'Escape') return;
      var btn = root.querySelector('[data-rp-share][aria-expanded="true"]');
      if (btn) { document.getElementById(btn.getAttribute('aria-controls')).hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });
  }

  document.querySelectorAll('.nn-rp, [data-nn-add-root]').forEach(function (root) {
    if (root.dataset.nnAddInit) return; /* the script can load twice on one page */
    root.dataset.nnAddInit = '1';
    init(root);
  });
})();
